import AddressListViewModel from "../view/addresslistviewmodel";
import PagedElements from "./pagedelements"

export default class PagedAddresses extends PagedElements<AddressListViewModel> {
    constructor(init?: Partial<PagedAddresses>) { super(init); }
}